import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import { AuthProvider } from '@contexts/AuthContext';
import { HouseholdProvider } from '@contexts/HouseholdContext';
import { initSentry } from './lib/sentry';
import { isTvMode } from './lib/runtime';
import './index.css';

// TV mode flips:
//   - `body.tv-mode` (legacy; some inherited CSS targets this)
//   - `html[data-tv-mode="1"]` (used by Tailwind's `tv:` variant plugin
//     so component styles can scope with `tv:text-2xl` etc.)
// Detection is memoized in runtime.ts.
if (isTvMode()) {
  document.body.classList.add('tv-mode');
  document.documentElement.dataset.tvMode = '1';
}

// Sentry boots first so AuthProvider / router crashes get captured. No-op
// when VITE_SENTRY_DSN is unset.
initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <HouseholdProvider>
          <App />
          <Toaster position="top-right" />
        </HouseholdProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
